import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GET_CERTIFICATES, DELETE_CERTIFICATE } from "api";
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import Layout from "containers/Layout/Layout";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import { useStyles as useStylesContentList } from "ui/styles/contentList";
import DownloadButton from "components/DownloadButton";
import CertificateTemplate from "containers/Templates/Certificate";
import { getFileName } from "services/Utils";
import { EnhancedTableStatusCell } from "@vocollege/components";
import GroupTitle from "components/GroupTitle";
import { EnhancedTableFilterValue } from "@vocollege/components/dist/EnhancedTable";
import { GeneralObject } from "@vocollege/app/dist/global";

const Certificates: React.FC = (props) => {
  let navigate = useNavigate();
  const classesContentList = useStylesContentList();
  const [educators, setEducators] = useState<EnhancedTableFilterValue[]>([]);

  const editItem = (id = "skapa") => {
    navigate(`/intyg/${id}`);
  };

  const handleDataChange = (data: any) => {
    setEducators([
      { label: I18n.get.actions.showAll, value: "all" },
      { label: I18n.get.misc.noEducator, value: "none" },
      ...data.allGroups.map((v: GeneralObject) => ({
        label: v.title,
        value: v.id,
      })),
    ]);
  };

  const getFilters = () => {
    return [
      {
        name: "educator",
        label: I18n.get.group.categories.educator,
        default: ["all"],
        multiple: true,
        values: educators,
      },
    ];
  };

  const getActionButtons = () => {
    let buttons = [];
    if (VoAuth.ability.can("update_own_certificates", "Cert")) {
      buttons.push("edit");
    }
    if (VoAuth.ability.can("delete_own_certificates", "Cert")) {
      buttons.push("delete");
    }
    return buttons;
  };

  const getCustomActionButtons = (row: any, index: number) => {
    return (
      <>
        <DownloadButton
          auditResource={{ resourceType: "Certificate", id: String(row.id) }}
          className={clsx(classesContentList.actionButton, {
            "vo-cert-download-from-list": index === 0,
          })}
          document={<CertificateTemplate item={row} />}
          fileName={`${getFileName([
            row && row.firstname,
            row && row.lastname,
          ])}.pdf`}
        />
      </>
    );
  };

  return (
    <>
      <Layout>
        <EnhancedTable
          enableSearch
          className="vo-global__top-bottom-space"
          title={I18n.get.certificate.labels.certificates}
          operations={{
            category: "certCertificates",
            get: GET_CERTIFICATES,
            delete: DELETE_CERTIFICATE,
          }}
          labels={{
            deleted: I18n.get.certificate.messages.certificateDeleted,
          }}
          columns={[
            { title: "ID", field: "id", width: 90 },
            { title: I18n.get.user.labels.firstname, field: "firstname" },
            { title: I18n.get.user.labels.lastname, field: "lastname" },
            {
              title: I18n.get.group.categories.educator,
              field: "educator",
              width: 200,
              render: (data) => <GroupTitle item={data?.educator} />,
            },

            {
              title: I18n.get.misc.created_at,
              field: "created_at",
              width: 200,
            },
            {
              title: I18n.get.misc.updated_at,
              field: "updated_at",
              width: 200,
            },
          ]}
          addItem={
            VoAuth.ability.can("create_own_certificates", "Cert")
              ? editItem
              : undefined
          }
          editItem={editItem}
          orderBy="UPDATED_AT"
          order="DESC"
          actionButtons={getActionButtons()}
          renderActionButtons={getCustomActionButtons}
          filters={getFilters()}
          onDataChange={handleDataChange}
        />
      </Layout>
    </>
  );
};

export default Certificates;
